<template>
  <b-modal v-model="isModalActive" :can-cancel="false">
    <div class="form-modal-widget">
      <div class="form-modal-header">
        <h1 v-if="!form.id">ADD NEW TV</h1>
        <h1 v-else>UPDATE TV</h1>
      </div>
      <div class="form-modal-body">
        <b-field label="Title">
          <b-input v-model="form.title" value="Kevin Garvey"></b-input>
        </b-field>

        <b-field label="TV logo">
          <upload-trigger
            :open="false"
            :enableinput="false"
            :required="false"
            :multiple="false"
            location="assets/uploaded/"
            :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'"
            name="main-image"
            :value="form.image"
            @onFileSelected="onImageSelected"
          >
            <div class="image-upload-widget">Choose Image to upload</div>
          </upload-trigger>
        </b-field>

        <b-field label="Description">
          <b-input
            v-model="form.description"
            maxlength="200"
            type="textarea"
          ></b-input>
        </b-field>

        <div class="row">
          <b-field style="width: 100%" label="Streaming link">
            <b-input v-model="form.player_url"></b-input>
          </b-field>
          <div class="h-spacer"></div>
          <b-field label="Visibility Status">
            <b-select v-model="form.visibility">
              <option value="Public">Public</option>
              <option value="Unlisted">Unlisted</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="form-modal-footer">
        <b-button :loading="submit_loading" @click="submitTv" type="is-primary"
          >SAVE</b-button
        >
        <b-button @click="onCancel" type="is-primary" outlined>CANCEL</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isModalActive: true,
    form: {
      id: null,
      title: "",
      image: "",
      category: "tv",
      description: "",
      player_url: "",
      visibility: "Public",
    },
    submit_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.setFormFields(vm.value);
    } else {
      vm.resetFormFields();
    }
  },
  methods: {
    setFormFields(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.description = item.description;
      vm.form.image = item.image;
      vm.form.category = item.category;
      vm.form.player_url = item.player_url;
    },
    resetFormFields() {
      let vm = this;
      vm.form.id = null;
      vm.form.title = "";
      vm.form.description = "";
      vm.form.image = "";
      vm.form.category = "tv";
      vm.form.player_url = "";
    },
    submitTv() {
      let vm = this;
      vm.submit_loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("STREAMING_ADDNEW_TV", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$store
          .dispatch("STREAMING_UPDATE_TV", vm.form)
          .then((response) => {
            vm.submit_loading = false;
            vm.$emit("saved");
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close");
    },
    onImageSelected(file) {
      let vm = this;
      vm.form.image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;
  @media (max-width: 628px) {
    width: 95% !important;
    .row {
      flex-direction: column;
    }
  }
  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;
    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}
#sideBartrue {
  left: 230px;
  @media (max-width: 768px) {
    left: 0;
  }
  .form-modal-widget  {
    @media (max-width: 846px) {
      width: 500px;
    }
    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
